<template>
  <div>
    <a-row :gutter="[16, 16]">
      <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 8 }">
        <listVehicle />
      </a-col>
      <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 16 }">
        <calendar :arrDate="arrDate" :logVehicleBooking="logVehicleBooking" @sendDateTimeFormat="sendDateTimeFormat"
          @viewVehicleBooking="viewVehicleBooking" :isCalendarLoaded="isCalendarLoaded"
          :startDateCalendar="startDateCalendar" :endDateCalendar="endDateCalendar" />
      </a-col>
    </a-row>

    <a-modal v-model="isShowModalBookingInfo" title="IC Vehicle Booking" cancel-text="Close"
      @ok="isShowModalBookingInfo = false">
      <div v-if="!isLoadedBookingInfo && !isEmptyVehicleBooking" class="div-isLoaded">
        <a-spin />
      </div>
      <div class="modal-info" v-if="isLoadedBookingInfo && !isEmptyVehicleBooking">
        <div v-for="(data, index) in listOfVehicleBooking" :key="'data' + index">
          <p style="text-align: right;" v-if="listOfVehicleBooking.length > 1">
            <strong>{{ index + 1 }}</strong>
          </p>
          <small>Reason</small>
          <p class="mt-5 mb-10">
            <strong>{{ data.reason_detail.eng_detail }}</strong>
          </p>
          <small>Remark</small>
          <p class="mt-5 mb-10">
            <strong>{{ data.remark }}</strong>
          </p>
          <small>Destination</small>
          <p class="mt-5 mb-10">{{ data.destination }}</p>
          <small>Date</small>
          <p class="mt-5 mb-5">
            Start :
            {{ moment(data.use_start).format("DD / MM / YYYY , HH:mm:ss") }}
          </p>
          <p class="mt-5 mb-10">
            End :
            {{ moment(data.use_end).format("DD / MM / YYYY , HH:mm:ss") }}
          </p>
          <small>Requestor</small>
          <p class="mt-5 mb-10 font-bold" style="color:green">
            {{ data.requestor_detail.name + ' ' + data.requestor_detail.surname }}
          </p>
          <small>Driver</small>
          <p class="mt-5 mb-10 font-bold" style="color:dodgerblue">
            {{ data.driver_detail.driver_detail.name + ' ' + data.driver_detail.driver_detail.surname }}
            <br>
            <small class="text-muted"><i>Phone</i> : {{ data.driver_detail.tel }} , <i>Office Phone</i> : {{
              data.driver_detail.driver_detail.telephone }}</small>
          </p>
          <small>Car</small>
          <p class="mt-5 mb-10 font-bold">
            {{ data.car_detail.code }}
          </p>
          <br>
          <hr class="" v-if="listOfVehicleBooking.length > 1 && index != listOfVehicleBooking.length - 1">
        </div>
      </div>
      <div v-if="isLoadedBookingInfo && isEmptyVehicleBooking">
        <a-empty><span slot="description">
            No Vehicle Booking.
          </span></a-empty>
      </div>
    </a-modal>

  </div>
</template>

<script>
import calendar from "./calendar.vue";
import listVehicle from "./list-vehicle.vue";

const formData = {
  content: "",
  remark: "",
  destination: "",
  requestor: "",
  use_start: "",
  use_end: "",
}
export default {
  components: {
    calendar,
    listVehicle,
  },
  data() {
    return {
      arrDate: [],
      dataTextFullMonth: "",
      logVehicleBooking: [],
      listOfVehicleBooking: [],
      dateSelectView: "",
      objData: Object.assign({}, formData),
      loadingAll: false,
      isCalendarLoaded: false,
      isShowModalBookingInfo: false,
      isLoadedBookingInfo: true,
      isEmptyVehicleBooking: false,
      startDateCalendar: '',
      endDateCalendar: '',
    };
  },
  mounted() {
    this.sendDateTimeFormat("start");
  },
  methods: {
    formatMonth(val) {
      return val.toString().length == 1 ? "0" + val.toString() : val.toString();
    },
    getDayInFirst(month, year) {
      return new Date(year, month, 1).getDate().toString().length == 1
        ? "0" + new Date(year, month, 1).getDate()
        : new Date(year, month, 1).getDate();
    },
    getDayInLast(month, year) {
      return new Date(year, month, 0).getDate().toString().length == 1
        ? "0" + new Date(year, month, 0).getDate()
        : new Date(year, month, 0).getDate();
    },
    async sendDateTimeFormat(...args) {
      this.loadingAll = true;
      this.arrDate = [];
      if (args[0] !== "start") {
        // select month & year
        const d = new Date(args[0].a._d);
        let month = Number.parseInt(d.getMonth()) + Number.parseInt(1);
        let year = d.getFullYear();
        let formatMount = this.formatMonth(month);
        let startMonth =
          year + "-" + formatMount + "-" + this.getDayInFirst(month, year);
        let endMonth =
          year + "-" + formatMount + "-" + this.getDayInLast(month, year);
        // set data to calendar
        this.arrDate.push({
          month: month,
          year: year,
          startDate: Number.parseInt(this.getDayInFirst(month, year)),
          endDate: Number.parseInt(this.getDayInLast(month, year)),
        });
        // now datetime vehicle booking
        await this.getVehicleBooking(
          this.moment(startMonth).format("YYYY-MM-DD"),
          this.moment(endMonth).format("YYYY-MM-DD")
        );
        //set date default
        this.startDateCalendar = this.moment(startMonth).format("YYYY-MM-DD")
        this.endDateCalendar = this.moment(endMonth).format("YYYY-MM-DD")
      }
      else {

        // now datetime
        const dnow = new Date();
        let monthNow = Number.parseInt(dnow.getMonth()) + Number.parseInt(1);
        let yearNow = dnow.getFullYear();
        let formatMountNow = this.formatMonth(monthNow);
        let startMonthNow =
          yearNow +
          "-" +
          formatMountNow +
          "-" +
          this.getDayInFirst(monthNow, yearNow);
        let endMonthNow =
          yearNow +
          "-" +
          formatMountNow +
          "-" +
          this.getDayInLast(monthNow, yearNow);
        // set data to calendar
        this.arrDate.push({
          month: monthNow,
          year: yearNow,
          startDate: Number.parseInt(this.getDayInFirst(monthNow, yearNow)),
          endDate: Number.parseInt(this.getDayInLast(monthNow, yearNow)),
        });
        // now get vehicleBooking
        await this.getVehicleBooking(
          this.moment(startMonthNow).format("YYYY-MM-DD"),
          this.moment(endMonthNow).format("YYYY-MM-DD"));

        //set date default
        this.startDateCalendar = this.moment(startMonthNow).format("YYYY-MM-DD")
        this.endDateCalendar = this.moment(endMonthNow).format("YYYY-MM-DD")
      }
      this.loadingAll = false;
    },
    openNotification(args) {
      this.$notification.open({
        style: {
          backgroundColor: args.backgroundColor,
          color: args.color,
        },
        message: function (h) {
          return h("div", [h("strong", { class: "" }, args.title)]);
        },
        description: args.msg,
      });
    },
    viewVehicleBooking(...args) {
      let dateTimeSelected = args[0]
      this.isShowModalBookingInfo = true;
      this.isEmptyVehicleBooking = false;
      this.isLoadedBookingInfo = false;
      this.objData = Object.assign({}, formData);
      this.dateSelectView = dateTimeSelected;
      this.getDetailVechicleBooking(dateTimeSelected);
    },
    async getDetailVechicleBooking(val) {
      let start = `${this.moment(val).format("YYYY-MM-DD")}T00:00:00+07:00`;
      let End = `${this.moment(val).format("YYYY-MM-DD")}T23:59:59+07:00`;
      try {
        const res = await this.$http.get(
          `/vehicle/booking/calendar/?timestart=${encodeURIComponent(
            start
          )}&timeend=${encodeURIComponent(End)}&status=approve,success`
        );
        if (res.status === 200) {
          if (res.data.length > 0) {
            this.listOfVehicleBooking = res.data
          } else {
            this.isEmptyVehicleBooking = true;
          }
          this.isLoadedBookingInfo = true;
        }
      } catch (error) {
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Problem issue connect api : /vehicle/booking/calendar/`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
        this.isLoadedBookingInfo = true;
      }
    },
    async getVehicleBooking(startMonth, endMonth) {
      try {
        this.isCalendarLoaded = false
        const res = await this.$http.get(
          `/vehicle/booking/calendar/?timestart=${encodeURIComponent(
            startMonth
          )}&timeend=${encodeURIComponent(endMonth)}&status=approve,success`
        );
        if (res.status === 200) {
          this.logVehicleBooking = [];
          this.logVehicleBooking = res.data.map((item) => ({
            ...item,
            type: "info",
            content: item.detail,
            colorcontent:
              item.status === "approve"
                ? "#0d9f3f"
                : item.status === "wait"
                  ? "#ffe562"
                  : "#ffb2b2",
          }));
          this.isCalendarLoaded = true
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.isCalendarLoaded = true
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Problem issue connect api : /booking/calendar/?timestart=${startMonth}&timeend=${endMonth}`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
      }
    },
  },
};
</script>

<style scoped>
.div-isLoaded {
  text-align: center;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}

.modal-info {
  overflow-y: scroll;
  max-height: 600px;
}

.readText {
  white-space: pre-line;
}
</style>